'use client';

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usePathname, useParams, useSearchParams } from 'next/navigation';

import { setShowMenu, setShowLoginFailModal } from '@/slices/popSlice';
import { userLogin, userMutate, userState } from '@/slices/userSlice';

import authClient from '@/common/apiClient/authClient';
import anaClient from '@/common/apiClient/anaClient';
import notificationClient from '@/common/apiClient/notificationClient';
import userClient from '@/common/apiClient/userClient';
import WebUrl from './WebUrl'; // 路徑判斷
import 'dayjs/locale/en';

import { setNotification, setNewNotification } from '@/slices/notificationSlice';
import { getSocketUrl } from '../../common/util';
import io from 'socket.io-client';
let socket;

const Layout = ({ locale }) => {
    const dispatch = useDispatch();
    const { user } = useSelector(userState);
    const pathname = usePathname();
    const params = useParams();
    const searchParams = useSearchParams();

    // 處理選單
    const handleMenu = () => {
        if (window.innerWidth < 1024) dispatch(setShowMenu(true));
    };

    // 取得 user 資料
    const fetchUser = async () => {
        try {
            const [{ user }, achievement] = await Promise.all([
                authClient.getUser(locale),
                userClient.getUserAchievement(),
            ]);

            // 如果是黑名單
            if (user?.blacklist) {
                dispatch(setShowLoginFailModal(true));
                await authClient.logout();
            } else if (user?.uid && achievement) dispatch(userLogin({ ...user, achievement }));
        } catch (e) {
            console.error(e);
        }
    };

    // 拿通知訊息資料
    const getNotifications = async () => {
        try {
            const { records, unreadCnt } = await notificationClient.getNotifications();

            if (records) dispatch(setNotification({ records, unreadCnt }));
        } catch (e) {
            console.error(e);
        }
    };

    // 建立 socket
    const createSocket = async () => {
        const socketUrl = getSocketUrl(window.location.host);
        socket = io(socketUrl, { transports: ['websocket'] });

        socket.on('connect', () => {
            console.log('connected:' + user.uid);
            // join user
            socket.emit('joinUser', { uid: user.uid, sites: [18, 1] });
        });

        // receive notify (新訊息)
        socket.on('notify', async (payload) => {
            console.log('notfiy payload:', payload);

            // 從其他裝置變更會員資料
            if (payload?.userChange) dispatch(userMutate(payload?.userChange));
            else dispatch(setNewNotification(payload));
        });

        // receive notify-read (接收變更訊息讀取狀態)
        socket.on('notify-read', async (payload) => {
            console.log('notify-read:', payload);

            await getNotifications();
        });
        socket.on('disconnect', (reason) => {
            console.log('disconnect:', reason);
        });
    };

    // 建立 access log
    const handleAccessLog = () => {
        let path;
        // 以下路徑需特別處理
        const paramMapping = {
            category: '[category]',
            newsSlug: '[newsSlug]',
            authorName: '[authorName]',
            keyword: '[keyword]',
        };

        Object.keys(paramMapping).forEach((key) => {
            if (params[key]) {
                path = pathname?.replace(params[key], paramMapping[key]);
            }
        });

        if (!path) path = pathname;

        const queryParams = {};
        for (const [key, value] of searchParams.entries()) {
            queryParams[key] = value;
        }

        const accessLog = {
            pathName: path,
            path: pathname,
            params: JSON.stringify(queryParams),
            source: queryParams?.source,
        };
        anaClient.createAccessLog(accessLog);
    };

    useEffect(() => {
        // 有 user時建立 socket連線
        // 若 user 有值，在 socket 中 join uid
        if (user?.uid) {
            createSocket();
            getNotifications();
        } else if (socket) {
            // 會員登出後切斷連結
            socket.disconnect();
        }
        return () => {
            socket?.disconnect();
        };
    }, [user]);

    useEffect(() => {
        window.addEventListener('resize', handleMenu);

        return () => window.removeEventListener('resize', handleMenu);
    }, []);

    useEffect(() => {
        fetchUser();
    }, []);

    useEffect(() => {
        handleAccessLog();
    }, [pathname]);

    return (
        <>
            {/* 網站路徑判斷 */}
            <WebUrl />
        </>
    );
};

export default Layout;
